function toWebpPath(path) {
  if (!path || typeof path !== "string") return null;
  return path.replace(/\.(png|jpe?g)$/i, ".webp");
}

export default function CompanyCard({ name, blurb, url, logo, backgroundImage, backgroundPosition = "center", priority = false, onSeeMore }) {
  const imageLoading = priority ? "eager" : "lazy";
  const fetchPriority = priority ? "high" : undefined;

  const logoImg = logo && (
    <img
      src={logo}
      alt={`${name} logo`}
      className="h-64 w-64 object-contain drop-shadow-lg"
      loading={imageLoading}
      fetchPriority={fetchPriority}
    />
  );

  const bgImg = (
    <img
      src={backgroundImage}
      alt=""
      aria-hidden
      className="w-full h-full object-cover opacity-[0.12] saturate-0 brightness-110 blur-[1.5px]"
      style={{ objectPosition: backgroundPosition }}
      loading={imageLoading}
      fetchPriority={fetchPriority}
    />
  );

  return (
    <div className="group relative rounded-2xl p-[4px] bg-gradient-to-r from-red-600 via-white to-blue-600">
      <div className="relative h-full rounded-[14px] border border-slate-200 bg-white
                      shadow-md transition-all duration-300 overflow-hidden
                      group-hover:shadow-xl group-hover:-translate-y-1">
        {/* Content */}
        <div className="relative h-full flex flex-col p-6 text-center justify-center items-center">
          {logo && (
            <div className="flex justify-center flex-grow">
              {priority && toWebpPath(logo) ? (
                <picture className="block">
                  <source srcSet={toWebpPath(logo)} type="image/webp" />
                  {logoImg}
                </picture>
              ) : (
                logoImg
              )}
            </div>
          )}

          {/* Image background — always use img so background is visible; no picture (WebP optional for logo only) */}
            <div className="absolute inset-0 pointer-events-none">
              {bgImg}
            </div>
           

          {/* Optional blurb*/}
          {/* {blurb && (
            <p className="mt-4 text-sm text-gray-600">{blurb}</p>
          )} */}

          <div className="flex items-center gap-3 mt-auto justify-center">
            <button
              onClick={onSeeMore}
              className="inline-flex items-center gap-1 rounded-lg border px-3 py-1.5 text-sm hover:bg-gray-50 transition-colors"
            >
              See more
            </button>

            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 rounded-lg bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-800 transition-colors"
            >
              Visit site
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}